import React from "react";

function About(props) {
  return (
    <section id="about" class="about">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 order-1 order-lg-2" data-aos="fade-left">
            <img src="assets/img/about.jpeg" class="img-fluid" alt="" />
            <br />
            <br />
            <img src="assets/img/New/features.jpg" class="img-fluid" alt="" />
          </div>

          <div
            class="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content"
            data-aos="fade-right"
          >
            <h3>About Us</h3>
            <p class="fst-italic">
              Knowledgeable Web Administrator who is proficient in all of the
              major programming languages. Adept in creating traffic reports
              backing up website data and working as part of a team. Specialized
              skills in JavaScript interactive online forms and developing
              efficient ways to update web contents.
            </p>
            <h4>Who We Are?</h4>
            <ul>
              <li>
                Black Box Software Solutions is an Afghanistan Firm that
                specializes in software development. Since 2017, the company has
                offered a wide range of high quality services in the
                development, delivery, and maintenance of software in
                Afghanistan. Our key market advantage is the ability to leverage
                a wealth of experience in this sector, a network of local and
                international partners, and a very competitive pricing strategy
                to deliver quality software solutions.
              </li>
            </ul>
            <h4>What We Do?</h4>
            <ul>
              <li>
                Black Box Software Solutions has delivered excellent software
                products and managed software projects from the inception of the
                idea, to requirements, design, coding, testing, and
                disseminating.
              </li>
              <li>
                <i class="bi bi-check-circle"></i> Customize solutions.
              </li>
              <li>
                <i class="bi bi-check-circle"></i> Business website solutions.
              </li>
              <li>
                <i class="bi bi-check-circle"></i> Inventory Management
                Softwares
              </li>
              <li>
                <i class="bi bi-check-circle"></i> Database Management
                Softwares.
              </li>
              <li>
                <i class="bi bi-check-circle"></i> Mobile Application
                Development.
              </li>
              <li>
                <i class="bi bi-check-circle"></i> Software Solutions for
                Medical Purpose
              </li>
              <li>
                <i class="bi bi-check-circle"></i> Trainings
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
